import { createReactExtension } from '@backstage/core-plugin-api';
import { homePlugin } from '@backstage/plugin-home';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const NotificationListWidget = homePlugin.provide(
  createReactExtension({
    name: 'NotificationListWidget',
    component: {
      lazy: () => import('./notification-list').then(m => m.NotificationList),
    },
    data: {
      'home.widget.config': {
        layout: {
          title: 'Notification List',
          description: 'This widget displays a list of notifications.',
          width: { minColumns: 12 },
          height: { minRows: 3 },
        },
      },
    },
  }),
);

// @NFS: Exporting the widget as a HomePageWidgetBlueprint to be used in the app.tsx overrides
export const notificationsWidget: ExtensionDefinition =
  HomePageWidgetBlueprint.make({
    name: 'notification-list-widget',
    params: {
      title: 'Notification List',
      description: 'This widget displays a list of notifications.',
      layout: {
        width: { minColumns: 12 },
        height: { minRows: 3 },
      },
      components: async () =>
        import('./notification-list').then(m => ({
          Content: m.NotificationList,
        })),
    },
  });
